import styled from 'styled-components';

export const AuthorInfo = styled.div<{IsCaseStudy: boolean}>`
    max-width: 768px;
    display: flex;
    align-items: center;
    margin: ${({IsCaseStudy}) => IsCaseStudy? "3rem auto 5rem 3rem" : "3rem auto 5rem auto"};
`;

export const Image = styled.div`
    margin-right: 20px;
    width: 64px;
    height: 64px;

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 100%;
    }
`;

export const Name = styled.div`
    span {
        font-size: 12px;
        margin-bottom: 2px;
        display: block;
        color: var(--light-grey);
    }

    a {
        font-size: 16px;
        color: var(--white);

        &:hover {
            color: var(--primary-on-hover);
        }
    }
`;